import React from 'react';
import styled from 'styled-components';

interface ContainerProps {
  fluid?: boolean;
  children: React.ReactNode;
}

const Container: React.FC<ContainerProps> = ({ fluid = false, children }) => {
  return <StyledContainer fluid={fluid}>{children}</StyledContainer>;
};

const StyledContainer = styled.div<{ fluid: boolean }>`
  width: 100%;
  max-width: ${props => (props.fluid ? '100%' : '1200px')};
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.lg};

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 0 ${props => props.theme.spacing.md};
  }
`;

export default Container;
